import { Controller } from "stimulus";
import Cookies from "js-cookie";

export default class extends Controller {
  clickStarButton(e) {
    const targetDataset = e.target.dataset;
    if (targetDataset.target === "#signInModal") {
      Cookies.set("portfolioNftContractId", targetDataset.nftContractId);
    }
  }
}